import { useCheckAdminAccess } from '@shared/client-api';

export const useIsTaskGripAdmin = () => {
	const { data, isLoading, error } = useCheckAdminAccess({
		query: {
			staleTime: 5 * 60 * 1000, // 5 minutes
			gcTime: 10 * 60 * 1000, // 10 minutes
			retry: false,
		},
	});

	// Always return false during loading/error to maintain stable hook behavior
	if (isLoading || error) {
		return false;
	}

	return data?.isTaskGripAdmin || false;
};
